type AlertContentPropsType = {
  children: React.ReactNode;
};

const AlertContent = ({
  children,
}: AlertContentPropsType): React.ReactElement => (
  <div className="font_body_regular_lg max-w-[276px] text-center content_secondary">
    {children}
  </div>
);

export default AlertContent;
